module.exports = __webpack_public_path__ + "static/media/location-maps-letter-f-arrow-serr1.2f1fe1a7.png";